export const KEYBOARD_KEYS = {
  UP: 'ArrowUp',
  DOWN: 'ArrowDown',
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  SPACE: 'Space',
  BACKSPACE: 'Backspace',
  TAB: 'Tab',
};
